import script from "./GanttChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GanttChart.vue?vue&type=script&setup=true&lang=js"

import "./GanttChart.vue?vue&type=style&index=0&id=f80b76f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f80b76f6"]])

export default __exports__